export interface AuthConfig {
  userPoolId: string;
  userPoolClientId: string;
  identityPoolId: string;
  region: string;
  cognitoDomain: string;
  redirectUri: string;
  apiGatewayUrl: string;
  streamingApiUrl: string;
  stage: string;
}

const BETA_CONFIG: AuthConfig = {
  userPoolId: 'us-east-1_c1oh16uYS',
  userPoolClientId: '1jr5f0crpqvl6go77r0fg54o66',
  identityPoolId: 'us-east-1:3386f213-d545-49d2-95f2-30abbee0d4e6',
  region: 'us-east-1',
  cognitoDomain: 'campaign-strategist-beta-us-east-1.auth.us-east-1.amazoncognito.com',
  redirectUri: window.location.hostname === 'localhost' 
    ? 'http://localhost:5000' 
    : `https://${window.location.hostname}`,
  apiGatewayUrl: 'https://h0rcstyp14.execute-api.us-east-1.amazonaws.com/prod',
  streamingApiUrl: 'https://h0rcstyp14.execute-api.us-east-1.amazonaws.com/prod',
  stage: 'Beta',
};

const GAMMA_CONFIG: AuthConfig = {
  userPoolId: 'us-east-1_7qmB4VVZw',
  userPoolClientId: '6pibk1edpoc7rrk6q5405t1k7p',
  identityPoolId: 'us-east-1:de006266-e94f-45fc-b1f4-b274a2de8db7',
  region: 'us-east-1',
  cognitoDomain: 'campaign-strategist-gamma-us-east-1.auth.us-east-1.amazoncognito.com',
  redirectUri: 'https://preprod-campaign-strategist.ads.amazon.dev',
  apiGatewayUrl: 'https://b10wdw6qvi.execute-api.us-east-1.amazonaws.com/prod',
  streamingApiUrl: 'https://tp2viwd3q7.execute-api.us-east-1.amazonaws.com/prod',
  stage: 'Gamma',
};

const PROD_CONFIG: AuthConfig = {
  userPoolId: 'us-east-1_A8nc8Ki8M',
  userPoolClientId: '741jm9oe7ubhvk3icfgjo3nvvv',
  identityPoolId: 'us-east-1:acab3d03-8934-41a7-9210-7d946bddd446',
  region: 'us-east-1',
  cognitoDomain: 'campaign-strategist-prod-us-east-1.auth.us-east-1.amazoncognito.com',
  redirectUri: 'https://campaign-strategist.ads.amazon.dev',
  apiGatewayUrl: 'https://qrojwwbrvd.execute-api.us-east-1.amazonaws.com/prod',
  streamingApiUrl: 'https://PLACEHOLDER.execute-api.us-east-1.amazonaws.com', // Will be updated after deployment
  stage: 'Prod',
};

function getStageFromHostname(): 'beta' | 'gamma' | 'prod' {
  const hostname = window.location.hostname;
  if (hostname.includes('localhost') || hostname.includes('integ-campaign-strategist')) return 'beta';
  if (hostname.includes('preprod-campaign-strategist')) return 'gamma';
  return 'prod';
}

/** Runtime config loaded from /runtime-config.json (deployed by CDK for personal stacks) */
let runtimeConfig: { apiGatewayUrl?: string; streamingApiUrl?: string } | null = null;
let runtimeConfigLoaded = false;

export async function loadRuntimeConfig(): Promise<void> {
  if (runtimeConfigLoaded) return;
  runtimeConfigLoaded = true;
  try {
    const response = await fetch('/runtime-config.json');
    if (response.ok) {
      runtimeConfig = await response.json();
    }
  } catch {
    // No runtime config — use hardcoded values (pipeline stages)
  }
}

export function getAuthConfig(): AuthConfig {
  const stage = getStageFromHostname();
  let config: AuthConfig;
  switch (stage) {
    case 'beta': config = BETA_CONFIG; break;
    case 'gamma': config = GAMMA_CONFIG; break;
    case 'prod': config = PROD_CONFIG; break;
  }
  // Override API URLs from runtime config (personal stacks)
  if (runtimeConfig) {
    if (runtimeConfig.apiGatewayUrl) config = { ...config, apiGatewayUrl: runtimeConfig.apiGatewayUrl };
    if (runtimeConfig.streamingApiUrl) config = { ...config, streamingApiUrl: runtimeConfig.streamingApiUrl };
  }
  return config;
}
